import { EnumAyaEventType } from '../enums/aya-event-type.enum';
import { toConversationState } from '../enums/conversation-state.enum';
import {
  IUserStreamEnvelope,
  IUserStreamReset,
  USER_STREAM_EVENTS,
  USER_STREAM_PROTOCOL
} from '../interfaces/user-stream.interface';

const record = (value: unknown): Record<string, unknown> | null =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;

const parse = (data: string): Record<string, unknown> | null => {
  try {
    return record(JSON.parse(data));
  } catch {
    return null;
  }
};

/** O reset chega sem `id:`, `conversation_id` e `seq`: é reconhecido antes do
 * envelope de conversa e não avança o cursor. */
export const toUserStreamReset = (data: string): IUserStreamReset | null => {
  const raw = parse(data);
  if (!raw || raw.type !== EnumAyaEventType.USER_STREAM_RESET) {
    return null;
  }
  const payload = record(raw.payload) ?? {};
  return {
    reason: typeof payload.reason === 'string' ? payload.reason : 'unknown',
    historyRequired: payload.history_required !== false
  };
};

export const toUserStreamEnvelope = (
  data: string
): IUserStreamEnvelope | null => {
  const raw = parse(data);
  if (
    !raw ||
    raw.protocol !== USER_STREAM_PROTOCOL ||
    typeof raw.conversation_id !== 'string' ||
    !raw.conversation_id ||
    typeof raw.seq !== 'number'
  ) {
    return null;
  }
  const type = USER_STREAM_EVENTS.find((known) => known === raw.type);
  if (!type) {
    return null;
  }
  const payload = record(raw.payload) ?? {};

  return {
    type,
    conversationId: raw.conversation_id,
    seq: raw.seq,
    payload: {
      ...(payload.state !== undefined && {
        state: toConversationState(payload.state) ?? undefined
      }),
      ...('title' in payload && {
        title: typeof payload.title === 'string' ? payload.title : null
      }),
      ...(typeof payload.created_at === 'string' && {
        createdAt: payload.created_at
      })
    }
  };
};
